var _style, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.4 16.9",
    style: {
      enableBackground: "new 0 0 12.4 16.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4BA84F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.4,7.5h7.5c0.3,0,0.7-0.3,0.7-0.6s-0.3-0.6-0.7-0.6H2.4H2.3C2,6.4,1.9,6.6,1.9,6.9C1.9,7.3,2.1,7.5,2.4,7.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.5,10.6H10c0.3,0,0.6-0.3,0.6-0.7S10.4,9.3,10,9.3H2.4c-0.3,0-0.5,0.3-0.5,0.7C1.9,10.3,2.2,10.6,2.5,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,12.3H2.4c-0.3,0-0.6,0.3-0.6,0.7s0.3,0.7,0.6,0.7H4c0.3,0,0.6-0.3,0.6-0.7S4.4,12.3,4,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,11.3c-0.1,0-0.3,0-0.5,0.2l-2.3,2.3L6.4,13c-0.2-0.2-0.3-0.2-0.4-0.2l0,0c-0.2,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.3-0.2,0.4c0,0.1,0,0.3,0.2,0.4l1.3,1.3c0.2,0.2,0.4,0.2,0.5,0.2s0.3,0,0.5-0.2l2.7-2.7c0.2-0.2,0.2-0.4,0.2-0.5 v-0.1C10.6,11.6,10.4,11.3,10,11.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,3.4c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.7-0.9-0.7H9.7V2c0-0.2,0-0.4-0.3-0.6H9.2H7.7 c0-0.2-0.1-0.5-0.2-0.6C7.3,0.3,6.6-0.1,6.1,0c-0.6,0-1,0.3-1.3,0.9C4.7,1.1,4.7,1.2,4.7,1.4H3.3C3.1,1.4,2.7,1.5,2.6,2v0.5H1.3 c-0.5,0-1,0.3-1.1,0.7C0,3.5,0,3.7,0,4v11.3c0,0.3,0,0.5,0.1,0.9c0.2,0.4,0.6,0.7,1.1,0.7h9.9c0.6,0,1.1-0.4,1.2-1V3.8L12.4,3.4z  M5.6,1.4c0-0.2,0.1-0.3,0.3-0.4l0.3-0.1c0.4-0.1,0.7,0.2,0.7,0.4L7,1.8c0,0.4,0,0.5,0.4,0.6h1.5v1.2H3.6V2.4h1.5 c0.3,0,0.5-0.3,0.5-0.5V1.4z M2.7,4.4c0.1,0.1,0.2,0.1,0.2,0.1h6.3c0,0,0.3,0,0.4-0.4V3.5h1.7v12.3l0,0H1l0,0V3.6l0,0h1.6V4 C2.6,4.2,2.6,4.3,2.7,4.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 6.2,
    cy: 1.5,
    r: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/icon-order.2f7fe1a91980133299c0d7d83b9a3a13.svg";
export { ForwardRef as ReactComponent };